import * as React from 'react';
import * as Redux from 'redux';

interface IAutocompleteProps {
    autocompleteResults: any[];
    onResultClicked(result: any): void;
    onMouseEnter?(id): void;
    onMouseLeave?(): void;
    activeIndex: number;
    searchTerm?: string;
    isActive?: boolean;
    testID?: string;
}

interface IAutocompleteResultProps {
    result: any;
    isActive: boolean;
    searchTerm?: string;
    onResultClicked(searchTerm: any): void;
    onMouseEnter?(id): void;
    onMouseLeave?(): void;
    id: number;
    testID?: string;
}

export class Autocomplete extends React.Component<IAutocompleteProps, any> {
    render() {
        return (
            <div className={`search-bar-search-autocomplete search-autocomplete ${this.props.autocompleteResults.length === 0 || !this.props.isActive ? '' : 'active'}`}>
                <ul id="ulAutocomplete" className="unlisted" data-cypressselector="autocomplete-list">
                    {this.props.autocompleteResults.map((r, i) =>
                        <AutocompleteResult
                            searchTerm={this.props.searchTerm}
                            onResultClicked={this.props.onResultClicked}
                            result={r}
                            id={i}
                            testID={this.props.testID}
                            key={i}
                            isActive={this.props.activeIndex === i}
                            onMouseEnter={this.props.onMouseEnter}
                            onMouseLeave={this.props.onMouseLeave}
                        />
                    )}
                </ul>
            </div>
        )
    }
}

class AutocompleteResult extends React.Component<IAutocompleteResultProps, any> {
    getClassName(): string {
        if (this.props.isActive)
            return 'highlighted';
        return '';
    }

    GetHighlightedAutoComplete() : string {
        // Want to escape all '\' characters for the Regex.  Also what to trim spaces and make it lower case for consistency
        var highlightedTerm = this.props.searchTerm
            .replace('\\', '\\\\')
            .replace('(', '\\(')
            .replace(')', '\\)')
            .trim()
            .toLowerCase();

        return this.props.result.toLowerCase().replace(new RegExp('(' + highlightedTerm + ')'), '<strong>$1</strong>');
    }

    htmlEncode(stringToEncode) {
        return { __html: stringToEncode };
    } 

    onResultClicked = () => {
        this.props.onResultClicked(this.props.result);
    }

    render() {
        return (
            <li className={this.getClassName()}
                onMouseLeave={this.props.onMouseLeave}
                onMouseEnter={() =>  this.props.onMouseEnter && this.props.onMouseEnter(this.props.id)}
                onClick={this.onResultClicked}
                data-testid={ `${this.props.testID}-result-${this.props.id}`}
            >
                <span dangerouslySetInnerHTML={this.htmlEncode(this.GetHighlightedAutoComplete())} />
            </li>
        )
    }
}